export default __webpack_public_path__ + "static/media/6.d2c7b279.jpg";